














import { store } from "@/store";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UpgradeDef } from '@/App.vue';

@Component
export default class Upgrade extends Vue {
  @Prop() private definition!: UpgradeDef;

  buy()
  {
    store.purchaseUpgrade(this.definition.id, this.definition.cost);
  }

  get costStr()
  {
    return Object.entries(this.definition.cost).map(([resource, amount]) => `${amount} ${resource}`).join(", ");
  }
}
